module.exports = __webpack_public_path__ + "img/gcash-banner1.9dd0df81.png";